import PropTypes from 'prop-types'
import React, { Component } from "react"
import { Alert, Col, Container, Row } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"

// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation"
import { userForgetPassword} from "../../store/actions"

import loginImg from "../../assets/img/broker-login.png"
import "../../assets/scss/login.scss"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FooterLogin from "components/VerticalLayout/FooterLogin"

const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || ""

class ForgetPasswordPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      turnstileToken: null,
    }

    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
    this.turnstileRef = null
    this.turnstileWidgetId = null
    this.turnstileRetry = null
  }

  componentDidMount() {
    const preload = document.createElement("link")
    preload.rel = "preload"
    preload.as = "image"
    preload.href = loginImg
    document.head.appendChild(preload)

    if (TURNSTILE_SITE_KEY) {
      this.loadTurnstile()
    }
  }

  componentDidUpdate(prevProps) {
    if (
      TURNSTILE_SITE_KEY &&
      prevProps.forgetError !== this.props.forgetError &&
      this.props.forgetError
    ) {
      this.resetTurnstile()
    }
  }

  componentWillUnmount() {
    this.destroyTurnstile()
  }

  loadTurnstile = () => {
    if (!TURNSTILE_SITE_KEY) return

    if (window.turnstile && this.turnstileRef) {
      if (this.turnstileWidgetId != null) {
        window.turnstile.remove(this.turnstileWidgetId)
        this.turnstileWidgetId = null
      }

      this.turnstileWidgetId = window.turnstile.render(this.turnstileRef, {
        sitekey: TURNSTILE_SITE_KEY,
        theme: "light",
        callback: (token) => this.setState({ turnstileToken: token }),
        "expired-callback": () => this.setState({ turnstileToken: null }),
        "error-callback": () => this.setState({ turnstileToken: null }),
      })
      return
    }

    this.turnstileRetry = setTimeout(this.loadTurnstile, 200)
  }

  resetTurnstile = () => {
    this.setState({ turnstileToken: null })
    if (window.turnstile && this.turnstileWidgetId != null) {
      window.turnstile.reset(this.turnstileWidgetId)
    }
  }

  destroyTurnstile = () => {
    if (this.turnstileRetry) {
      clearTimeout(this.turnstileRetry)
      this.turnstileRetry = null
    }
    if (window.turnstile && this.turnstileWidgetId != null) {
      window.turnstile.remove(this.turnstileWidgetId)
      this.turnstileWidgetId = null
    }
  }

  // handleValidSubmit
  handleValidSubmit(event, values) {
    if (TURNSTILE_SITE_KEY && !this.state.turnstileToken) {
      return
    }
    this.props.userForgetPassword(
      {
        ...values,
        turnstileToken: this.state.turnstileToken,
      },
      event
    )
  }

  render() {
    const { turnstileToken } = this.state
    const turnstileRequired = Boolean(TURNSTILE_SITE_KEY)
    const canSubmit = !turnstileRequired || Boolean(turnstileToken)

    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        <div className="account-pages">
          <Container>
            <Row className="justify-content-center align-items-center vh-100">
              <Col lg={11} xl={10}>
                <div className="login-shell-card overflow-hidden my-4">
                  <Row className="g-0 align-items-center">
                    <Col lg={6} md={6}>
                      <div className="login-form-panel">
                        <div className="login-heading">
                          <h1>Forgot Password</h1>
                        </div>
                        <div className="p-2">
                          <AvForm
                            className="form-horizontal"
                            method="post"
                            onValidSubmit={this.handleValidSubmit}
                          >
                            {this.props.forgetError ? (
                              <Alert color="danger">{this.props.forgetError}</Alert>
                            ) : null}
                            {this.props.forgetSuccessMsg ? (
                              <Alert color="success">{this.props.forgetSuccessMsg}</Alert>
                            ) : null}

                            <div className="form-group mb-3">
                              <AvField
                                name="userName"
                                label="Email Address"
                                className="form-control border-r-50"
                                placeholder="Enter email"
                                type="email"
                                required
                              />
                            </div>

                            {turnstileRequired ? (
                              <div
                                className="login-turnstile"
                                ref={(el) => {
                                  this.turnstileRef = el
                                }}
                              />
                            ) : null}

                            <div className="mt-3 d-grid">
                              <button
                                className="btn btn-login btn-block"
                                type="submit"
                                disabled={!canSubmit}
                              >
                                Submit
                              </button>
                            </div>

                            <div className="mt-4">
                              <Link to="/login" className="login-forgot-link">
                                <i className="mdi mdi-lock me-1" /> Back to login
                              </Link>
                            </div>
                          </AvForm>
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} md={6} className="d-none d-md-block">
                      <div className="login-art-panel">
                        <img
                          src={loginImg}
                          className="img-fluid login-art-img"
                          alt="Forgot password"
                          fetchPriority="high"
                          decoding="async"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
          <FooterLogin />
        </div>
      </React.Fragment>
    )
  }
}

ForgetPasswordPage.propTypes = {
  forgetError: PropTypes.any,
  forgetSuccessMsg: PropTypes.any,
  history: PropTypes.object,
  userForgetPassword: PropTypes.func,
}

const mapStateToProps = ({ ForgetPassword }) => ({
  forgetError: ForgetPassword?.forgetError,
  forgetSuccessMsg: ForgetPassword?.forgetSuccessMsg,
})
const mapDispatchToProps = dispatch => ({
  userForgetPassword: (data) => dispatch(userForgetPassword(data)),
 })
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ForgetPasswordPage)
)
